export function generateElapsedTimeEventName(elapsedTime: number): string {
    const range = 500;
    const diff = elapsedTime / range;

    return diff % 1 === 0 ? `Elapsed ${diff * range}ms` : `Elapsed ${Math.floor(diff) * range}-${Math.ceil(diff) * range}ms`;
}
